// src/components/common/useConfirmationModal.js

import React, { useState } from 'react';
import Modal from './Modal'; // O componente Modal será importado aqui

export default function useConfirmationModal() {
    const [modalConfig, setModalConfig] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const showConfirmation = (config) => {
        setIsLoading(false);
        setModalConfig({
            ...config,
            onConfirm: async (...args) => {
                try {
                    setIsLoading(true);
                    if (config.onConfirm) await config.onConfirm(...args);
                } finally {
                    setIsLoading(false);
                    setModalConfig(null);
                }
            },
            onCancel: () => {
                if (config.onCancel) config.onCancel();
                setIsLoading(false);
                setModalConfig(null);
            }
        });
    };

    const ConfirmationModal = () => modalConfig && <Modal {...modalConfig} isLoading={isLoading} />;
    return { ConfirmationModal, showConfirmation };
}
